/* eslint sort-keys: "error" */
export default {
  /* german */
  de: {
    'company': 'Firma | Firmen',
    'company_created': 'Firma erstellt',
    'company_customer_number': 'Kundennummer',
    'company_deleted': 'Firma gelöscht | Firmen gelöscht',
    'company_details': 'Details',
    'company_industry': 'Industrie / Bereich',
    'company_name': 'Firmenname',
    'company_updated': 'Firma aktualisiert',
    'company_website': 'Webseite',
    'create_company': 'Firma hinzufügen',
    'update_company': 'Firma bearbeiten'
  },

  /* english */
  en: {
    'company': 'Company | Companies',
    'company_created': 'Company Created',
    'company_customer_number': 'Customer Number',
    'company_deleted': 'Company Deleted | Companies Deleted',
    'company_details': 'Details',
    'company_industry': 'Industry',
    'company_name': 'Company Name',
    'company_updated': 'Company edited',
    'company_website': 'Website',
    'create_company': 'Add Company',
    'update_company': 'Edit Company'
  }
}
